<template>
  <div>
    <div v-if="!isMobile" class="table-wrapper">
      <table class="table">
        <thead class="table__head table__row">
          <tr>
            <th class="table__cell">{{ $t("COMMAND TYPE") }}</th>
            <th class="table__cell">{{ $t("COMMAND RESULT") }}</th>
            <th class="table__cell">{{ $t("PURPOSE") }}</th>
            <th class="table__cell">{{ $t("DETAILS") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table__row" v-for="row in commands" :key="row.uuid">
            <td class="table__cell">
              <span class="table__date">
                {{ getDate(row.added) }}
              </span>
              {{ $t(row.type.toUpperCase()) }}
            </td>
            <td class="table__cell table__cell_nw">
              <span class="table__date">
                {{ getDate(row.acknowledged) }}
              </span>
              <span
                class="table__status g-status"
                :class="{
                  'g-status_success': /^ok/i.test(row.status),
                  'g-status_error': /error|failed/i.test(row.status),
                }"
              >
                {{ $t(row.status.toUpperCase(), row.status) }}
              </span>
            </td>
            <td class="table__cell">{{ row.params.purpose }}</td>
            <td class="table__cell" v-html="getDetails(row.params)"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="commands">
      <div class="command" v-for="command in commands" :key="command.uuid">
        <span class="command__heading">{{ $t("COMMAND TYPE") }}</span>
        <span class="command__date">
          {{ getDate(command.added) }}
        </span>
        {{ $t(command.type.toUpperCase()) }}
        <span class="command__heading">{{ $t("COMMAND RESULT") }}</span>
        <span class="command__date">
          {{ getDate(command.acknowledged) }}
        </span>
        <span
          class="command__status g-status"
          :class="{
            'g-status_success': /^ok/i.test(command.status),
            'g-status_error': /error|failed/i.test(command.status),
          }"
        >
          {{ $t(command.status.toUpperCase(), command.status) }}
        </span>
        <span class="command__heading">{{ $t("PURPOSE") }}</span>
        <span>{{ command.params.purpose }}</span>
        <template v-if="getDetails(command.params)">
          <span class="command__heading">{{ $t("DETAILS") }}</span>
          <span v-html="getDetails(command.params)"></span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    commands: Array,
  },
  data() {
    return {
      isMobile: window.innerWidth <= 767 || window.innerHeight <= 767,
    };
  },
  methods: {
    getDetails(params) {
      if (params.sign) {
        return `${params.sign.status}<br>${params.sign.status_text}`;
      }
      if (params.jit) {
        return `${params.jit.status_text}`;
      }
      if (params.error) {
        return params.error;
      }
      return '';
    },
    getDate(stamp) {
      if (!+stamp) {
        return this.$t('NA');
      }

      const date = new Date(stamp * 1000);
      return `${date.toLocaleDateString()}, ${date.toLocaleTimeString()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.table-wrapper {
  @include notebook {
    overflow-x: auto;
    width: 100vw;
    margin-left: -8px;
  }
}

.command {
  padding: 13px 0;
  border-bottom: 1px solid #e5e5e5;

  &:first-child {
    border-top: 1px solid #e5e5e5;
  }

  &__heading {
    font-size: 15px;
    font-weight: 500;
    display: block;
    margin-bottom: 5px;

    &:not(:first-child) {
      margin-top: 10px;
    }
  }

  &__date {
    display: block;
    white-space: nowrap;
    color: $text-secondary;
    font-size: 12px;
    margin-bottom: 5px;
  }
}

.table__date,
.command__date {
  display: block;
  white-space: nowrap;
  color: $text-secondary;
  font-size: 12px;
  margin-bottom: 5px;
}

.table__status,
.command__status {
  font-size: 14px;
  white-space: nowrap;
}

.table__button,
.command__button {
  padding-top: 0px;
  padding-bottom: 1px;
  margin-left: 5px;
}

.table {
  text-align: left;
  width: 100%;

  &__head {
    font-weight: 500;
  }

  &__cell {
    padding: 8px;

    &_nw {
      white-space: nowrap;
    }
  }

  &__row {
    border-bottom: 1px solid #e5e5e5;

    &:hover {
      background-color: var(--lighter-primary);
    }
  }
}
</style>
